import routes from './affinities.routes';

export const affinitiesModule = {
    routes
};